import React, { useEffect, useState } from 'react';
import { useHomePageContentStore } from "../../../hooks/HomePageContent";
import { isArray } from "underscore";
import System from "../../../helper/system";
import Pagination from "src/component/Global/Pagination"
import Helper from "src/helper/Helper";
import useReduxState from "src/hooks/useReduxState";
import { DateRangePicker } from "rsuite";
import { startOfDay, endOfDay, subMonths, subDays } from "date-fns";
import moment from "moment";
import NoResultContent from "../NoResultContent";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";
import stickyTableCommon from "src/helper/stickyTableCommon";
let c = System.getParams();

const ProductDocumentsTabContent = () => {
  const [selectedFilterArr, setSelectedFilterArr] = useState([]);
  const [firstServerCall, setFirstServerCall] = useState(true);
  const [orderby, setOrderby] = useState("");
  const [orderbyDirection, setOrderbyDirection] = useState("asc");
  const [selectedFilterList, setSelectedFilterList] = useReduxState([], "selectedFilterList");
  const [{ documentContentList, documentContentFacets, documentContentCount },
    { get_document_list }, { set_individual_tabs_count }] = useHomePageContentStore();
  const [dateRangeObject, set_dateRangeObject] = useState([null, null]);
  const [dateRangeSelectedPredefined, set_dateRangeSelectedPredefined] = useState("");
  const [filterObjCount, setFilterObjCount] = useState({});
  const [facetPanel, setFacetPanel] = useState({});
  const [filterFacet, setFilterFacet] = useState({});
  const { translation:t } = System;
  const removeSpecificSelectedFilter = (filter) => {
    const filterListWithoutSelectedFilter = selectedFilterList.filter(
      (existingFilter) => existingFilter !== filter
    );
    setSelectedFilterList(filterListWithoutSelectedFilter);
  };

  const [__check] = useAxiosIndicatorCheck();
  const [listObj, setListObj] = useState({
    pageCount: 0,
    page: 1,
    limit: 20,
    sortBy: 'asc',
    sortOrder: '',
    ascDesField: {}
  });

  useEffect(() => {
    const getList = async () => {
      await fetchAPiCall(firstServerCall);
      await setFirstServerCall(false);
    };
    getList();
  }, []);


  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [documentContentList])

  useEffect(() => {
    if (
      documentContentFacets && Object.entries(documentContentFacets).length > 0
    ) {
      const obj = { ...filterObjCount };
      Object.entries(documentContentFacets).map((facet, index) => {
        if (Object.entries(documentContentFacets[facet[0]]) && Object.entries(documentContentFacets[facet[0]]).length > 9) {
          obj[facet[0]] = 9;
        } else {
          obj[facet[0]] = Object.entries(
            documentContentFacets[facet[0]]
          ).length;
        }
      });
      setFilterObjCount(obj);
    }
  }, [documentContentFacets]);

  useEffect(() => {
    const getList = async () => {
      await fetchAPiCall();
    };
    if (firstServerCall === false) {
      getList();
    }
  }, [listObj.page]);

  useEffect(() => {
    async function fetchHere() {
      if (documentContentList && documentContentList.length > 0) {
        await fetchData();
        await setFirstServerCall(false);
      }
    }

    fetchHere();
  }, [documentContentList]);

  const fetchData = async () => {
    set_individual_tabs_count('docCount', documentContentCount)
    const total = documentContentCount;
    setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
  };

  useEffect(() => {
    const getList = async () => {
      if (listObj.page === 1) {
        await fetchAPiCall();
      } else {
        setListObj({ ...listObj, page: 1 })
      }
    };
    if (firstServerCall === false) {
      getList();
    }
  }, [listObj.limit, listObj.sortBy, selectedFilterList, orderby, orderbyDirection, dateRangeObject]);

  const handlePageClick = async (data) => {
    let here_page = 0;
    here_page = data.selected + 1;
    setListObj({ ...listObj, page: here_page })
    Helper.scrollTop();
  };

  const setPageLimit = async (event) => {
    setListObj({ ...listObj, limit: event.target.value })
  };

  const fetchAPiCall = async () => {
    __set("DOCUMENT_API_CALL");
    let dateRangeMomentObject = [...dateRangeObject];
    if (dateRangeMomentObject) {
      if (dateRangeMomentObject[0]) {
        dateRangeMomentObject[0] = moment(dateRangeMomentObject[0])
          .utc()
          .utcOffset(0)
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toISOString();
      }
      if (dateRangeMomentObject[1]) {
        dateRangeMomentObject[1] = moment(dateRangeMomentObject[1])
          .utc()
          .utcOffset(0)
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toISOString();
      }
    }
    await get_document_list({
      search: c.search,
      selectedFilterList,
      skip: Helper.getSkipCount(listObj.page, listObj.limit),
      top: listObj.limit,
      orderby: orderby !== "" ? orderby + ' ' + orderbyDirection : "DocumentType",
      dateRangeMomentObject
    });
    __remove("DOCUMENT_API_CALL");
  };

  const getNameForFilterBox = (mainKey) => {
    if (mainKey === "DocumentType") {
      return "Document Type";
    }
    if (mainKey === "FileFormat") {
      return "File Format";
    }
    return mainKey;
  };

  const setStatusOfFilter = (filterName, fieldName) => {
    let list = [...selectedFilterList];
    const foundIndex = list.findIndex((el) => el.filterName === filterName);

    if (foundIndex === -1) {
      list.push({ filterName, fieldName });

      if (!filterFacet[fieldName]) {
        const existingField = Object.keys(filterFacet).find(key => key !== fieldName);
        if (existingField) {
          delete filterFacet[existingField];
        }
        filterFacet[fieldName] = {};
      }
    } else {
      list.splice(foundIndex, 1);
    }

    const updatedFilterArray = ["DocumentType", "FileFormat", "Manufacturer"]
      .filter(type => list.some(filter => filter.fieldName === type));

    setSelectedFilterArr(updatedFilterArray);
    setSelectedFilterList(list);
  };

  const getStatusOfForFieldActivated = (filterName) => {
    let status = false;

    if (selectedFilterList && selectedFilterList.length > 0) {
      selectedFilterList.map((v, i) => {
        if (v.filterName === filterName && status === false) {
          status = true;
        }
      });

    }
    return status;
  };

  const getOrderByClass = (columnName) => {
    if (columnName === orderby) {
      return "sorting sorting_" + orderbyDirection;
    }
    return "sorting";
  };

  const toggleOrderBy = async (columnName) => {
    let direction = orderbyDirection === "desc" ? "asc" : "desc"
    setOrderbyDirection(direction);
    setOrderby(columnName);
  };

  const getDisableStatus = (key, disableVal) => {
    if (filterFacet && Object.keys(filterFacet).length > 0) {
      if (filterFacet[key]) {
        return false;
      }
    }
    return disableVal;
  };

  const noStockValidationMessage = (vMain, iMain) => {
    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <h4 className="panel-title">
            <a
              data-toggle="collapse"
              data-parent="#accordion"
              href={"#documentCollapse" + iMain}
              onClick={() => setFacetsPanelStatus("documentCollapse" + iMain)}
            >
              {getNameForFilterBox(iMain)}
            </a>
          </h4>
        </div>
        <div
          id={"documentCollapse" + iMain}
          className="panel-collapse collapse in"
        >
          <div className="panel-body">
            {vMain &&
              Object.entries(vMain).map((v, i) => (
                <React.Fragment key={i}>
                  {i <= filterObjCount[iMain] && (
                    <React.Fragment key={i}>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={v[1].slug}
                          checked={getStatusOfForFieldActivated(
                            v[1].Name,
                            iMain
                          )}
                          onChange={(e) => {
                            setStatusOfFilter(v[1].Name, iMain);
                          }}
                          disabled={
                            getDisableStatus(iMain, v[1].disabled)
                          }
                          name={v[1].slug}
                        />
                        <label className="form-check-label" htmlFor={v[1].slug}>
                          {" "}
                          {v[1].Name}
                          <span className="filter-count"> ({v[1].Count})</span>
                        </label>
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>
    );
  };

  const Ranges = [
    {
      key: "Day7",
      label: t('last7Days'),
      slug: "Last 7 days",
      value: [startOfDay(subDays(new Date(), 6)), endOfDay(new Date())],
      placement: "left",
    },
    {
      key: "Day30",
      label: t('last30Days'),
      slug: "Last 30 days",
      value: [startOfDay(subDays(new Date(), 29)), endOfDay(new Date())],
      placement: "left",
    },
    {
      key: "Day60",
      label: t('last60Days'),
      slug: "Last 60 days",
      value: [startOfDay(subDays(new Date(), 59)), endOfDay(new Date())],
      placement: "left",
    },
    {
      key: "Month12",
      label: t('last12Months'),
      slug: "Last 12 months",
      value: [startOfDay(subMonths(new Date(), 12)), endOfDay(new Date())],
      placement: "left",
    },
  ];

  const setFacetsPanelStatus = (panelType) => {
    let facetPanelDisplayStatus = true;
    if (panelType && panelType.trim() !== "") {
      let _facetPanel = document.getElementById(panelType);
      if (_facetPanel && _facetPanel.classList.contains("in")) {
        facetPanelDisplayStatus = false;
      }
    }
    let _facetObj = { ...facetPanel };
    if (_facetObj[panelType] === undefined) {
      _facetObj[panelType] = {};
    }
    _facetObj[panelType] = { status: facetPanelDisplayStatus };
    setFacetPanel(_facetObj);
    return facetPanelDisplayStatus;
  };

  const getFacetsPanelStatus = (panelType) => {
    if (
      Object.keys(facetPanel).length > 0 && facetPanel["documentCollapse" + panelType]
    ) {
      return facetPanel["documentCollapse" + panelType].status
        ? "text-blue2 font-bold"
        : "d-none text-blue2 font-bold";
    }
    return "text-blue2 font-bold";
  };

  useEffect(() => {
    if (documentContentList && isArray(documentContentList) && documentContentList.length) {
      stickyTableCommon('document-table', toggleOrderBy)
    }
  }, [documentContentList, __check(['DOCUMENT_API_CALL']).status])

  const onChangeDatePicker = (dates, event) => {
    set_dateRangeObject(dates);
    if (dateRangeObject) {
      setSelectedFilterArr((prevValue) => [
        ...prevValue,
        "dateRange",
      ]);
    }
    $(".rs-picker-daterange-predefined")
      .find("button")
      .removeClass("selected");
    if (event.target.getAttribute("slug")) {
      set_dateRangeSelectedPredefined(
        event.target.getAttribute("slug")
      );
      $(".rs-picker-daterange-predefined")
        .find(
          'button[slug="' +
          event.target.getAttribute("slug") +
          '"]'
        )
        .addClass("selected");
    } else {
      set_dateRangeSelectedPredefined("");
    }
  }

  const onEnterDatePicker = () => {
    $(".rs-picker-daterange-predefined")
      .find("button")
      .removeClass("selected");
    if (
      dateRangeSelectedPredefined &&
      dateRangeSelectedPredefined.trim() != ""
    ) {
      $(".rs-picker-daterange-predefined")
        .find(
          'button[slug="' +
          dateRangeSelectedPredefined +
          '"]'
        )
        .addClass("selected");
    }
  }
  return (
    <>
      <div className="filter-records">
        <span>
          Showing 1-{listObj.limit} of {documentContentCount} {t('documentResultsFor')}{" "}
          <b>"{c.search}"</b>
        </span>
      </div>
      <div className="documents-tab-wrapper">
        <div className="mb-1 mt-3 global-filter container-fluid maxw100">
          <div className="group-filters">
            <div className="group-filter-item d-flex flex-wrap align-items-center">
              {Array.isArray(selectedFilterList) &&
                selectedFilterList.length > 0 && (
                  <span className="filter-title text-transform text-uppercase me-2">
                    <b>{t('filter')}</b>
                  </span>
                )}
              {selectedFilterList &&
                Array.isArray(selectedFilterList) &&
                selectedFilterList.length > 0 &&
                selectedFilterList.map((filter, i) => (
                  <>
                    <span className="button-white button-small" key={i}>
                      <span tabindex="-1" classNmae="filter-item">
                        {filter.filterName}
                      </span>
                      <a>
                        <i
                          onClick={() => removeSpecificSelectedFilter(filter)}
                          className="fa fa-times"
                        ></i>
                        <span className="sr-only">{t('removeFilter')}</span>
                      </a>
                    </span>
                  </>
                ))}
            </div>
          </div>
        </div>
        <div className="bs5 container-fluid maxw100">
          <div className="bs5 row mt-3">
            <div className="col-lg-3 tab-sidebar">
              <div className="m-b-20 newcontent-filter">
                <div className="bs5 d-flex justify-content-between">
                  <span className="text-black font-bold mb-1 font-14">
                    {t('narrowYourResults')}
                  </span>
                  <a
                    href={void 0}
                    onClick={() => {
                      setSelectedFilterList([]);
                      set_dateRangeObject([null, null]);
                      set_dateRangeSelectedPredefined("");
                    }}
                  >
                    {t('clearAll')}
                  </a>
                </div>
                <div className="panel-group" id="accordion">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <h4 className="panel-title">
                        <a
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href={"#documentCollapseDate"}
                        >
                          {t('dateLoaded')}
                        </a>
                      </h4>
                    </div>
                    <div
                      id={"documentCollapseDate"}
                      className="panel-collapse collapse in"
                    >
                      <div className="panel-body text-blue2 order-date-range-filter w-100">
                        <div className="bs5 d-flex justify-content-between">
                          <span className="text-black">{t('dateRange')}</span>
                          <a
                            href={void 0}
                            onClick={() => {
                              const existingArrWithoutDateRange =
                                selectedFilterArr.filter(
                                  (filterName) => filterName != "dateRange"
                                );
                              setSelectedFilterArr(existingArrWithoutDateRange);
                              set_dateRangeObject([null, null]);
                              set_dateRangeSelectedPredefined("");
                            }}
                          >
                            {t('clearRange')}
                          </a>
                        </div>
                        <DateRangePicker
                          style={{ width: "100% !important" }}
                          placeholder={t('selectRange')}
                          onChange={(dates, event) => onChangeDatePicker(dates, event)}
                          onEnter={() => onEnterDatePicker()}
                          value={dateRangeObject}
                          character=" - "
                          cleanable={false}
                          format={Helper.getDatepickerFormat()}
                          ranges={Ranges}
                          editable={false}
                          className="w-100"
                        />
                      </div>
                    </div>
                    {documentContentFacets &&
                      Object.entries(documentContentFacets).map((vIn, i) => (
                        <React.Fragment key={i}>
                          {noStockValidationMessage(vIn[1], vIn[0])}
                          {Object.entries(vIn[1]).length > 9 && (
                            <div className="m-2">
                              <a
                                href={void 0}
                                onClick={() => {
                                  if (filterObjCount[vIn[0]] <= 9) {
                                    const obj = { ...filterObjCount };
                                    obj[vIn[0]] = Object.entries(vIn[1]).length;
                                    setFilterObjCount(obj);
                                  } else {
                                    const obj = { ...filterObjCount };
                                    obj[vIn[0]] = 9;
                                    setFilterObjCount(obj);
                                  }
                                }}
                                className={getFacetsPanelStatus(vIn[0])}
                              >
                                {filterObjCount[vIn[0]] <= 9
                                  ? t('seeMore')
                                  : t('seeLess')}
                              </a>
                            </div>
                          )}
                        </React.Fragment>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-9 tab-data">
              <div className="all-content">
                <div className="all-content-header">
                  <div className="bs5 row mt-1">
                    <div className="col-auto">
                      <div className="font-oswald font-light font-30 text-uppercase">
                        {t('documents')}
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="position-relative">
                  <div>
                    {__check(['DOCUMENT_API_CALL'], { overlay: true }).render}
                  </div>
                  <div id="sticky-table-wrapper" className="all-content-body sticky-table-wrapper">
                    <div className="table-responsive">
                      <table id="document-table" className="bs5 table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th>
                              <span>{t('title')}</span>
                              <span aria-label="Title"
                                className={'sort-container ' + getOrderByClass("Title")}
                                onClick={async () => {
                                  await toggleOrderBy("Title");
                                }}
                              ></span>
                            </th>
                            <th>
                              <span>{t('manufacturer')}</span>
                              <span aria-label="Manufacturer"
                                className={'sort-container ' + getOrderByClass("Manufacturer")}
                                onClick={async () => {
                                  await toggleOrderBy("Manufacturer");
                                }}
                              ></span>
                            </th>
                            <th>
                              <span>{t('dateLoaded')}</span>
                              <span aria-label="DatePublished"
                                className={'sort-container ' + getOrderByClass("DatePublished")}
                                onClick={async () => {
                                  await toggleOrderBy("DatePublished");
                                }}
                              ></span>
                            </th>
                            <th>
                              <span>{t('documentType')}</span>
                              <span aria-label="DocumentType"
                                className={'sort-container ' + getOrderByClass("DocumentType")}
                                onClick={async () => {
                                  await toggleOrderBy("DocumentType");
                                }}
                              ></span>
                            </th>
                            <th>
                              <span>{t('fileFormat')}</span>
                              <span aria-label="FileFormat"
                                className={'sort-container ' + getOrderByClass("FileFormat")}
                                onClick={async () => {
                                  await toggleOrderBy("FileFormat");
                                }}
                              ></span>
                            </th>
                          </tr>
                        </thead>
                        {documentContentList &&
                          isArray(documentContentList) &&
                          documentContentList.length > 0 && (
                            <tbody>
                              {documentContentList.map((v, i) => (
                                <tr key={i} className="align-middle">
                                  <td>
                                    <a
                                      href={v.AssetUrl}
                                      target="_blank"
                                      title={v.LongDescription}
                                      className="text-blue2 font-bold font-13"
                                    >
                                      {v.Title ? v.Title : v.LongDescription}
                                    </a>
                                  </td>
                                  <td>
                                    <div className="font-13">
                                      {v.Manufacturer}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="font-13">
                                      {v.DatePublishedObjectString}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="font-13">
                                      {v.DocumentType}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="font-13">{v.FileFormat}</div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          )}
                      </table>
                    </div>

                    {!firstServerCall && c.search && (!documentContentList || !Array.isArray(documentContentList) || documentContentList.length === 0) && (
                      <NoResultContent message={`${t('noResultsFoundFor')} <b>" ${c.search}"</b>.`} />
                    )}
                  </div>
                  {documentContentList &&
                    isArray(documentContentList) &&
                    documentContentList.length > 0 && (
                      <div className="pagination-row">
                        <Pagination
                          pageCount={listObj.pageCount}
                          handlePageClick={handlePageClick}
                          setPageLimit={setPageLimit}
                          page={listObj.page - 1}
                          limit={listObj.limit}
                        />
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDocumentsTabContent;
